import { Show } from 'solid-js';
import type { ProjectManifest } from '../types/project';
import type { PixelIconName } from '../types/window';
import { PixelIcon } from './PixelIcon';
import { ProjectIcon } from './ProjectIcon';

interface DesktopIconProps {
  id: string;
  label: string;
  icon: PixelIconName;
  project?: ProjectManifest;
  selected: boolean;
  onSelect: (id: string) => void;
  onOpen: () => void;
}

export function DesktopIcon(props: DesktopIconProps) {
  function handleClick(event: MouseEvent) {
    event.stopPropagation();
    props.onSelect(props.id);
    if (window.matchMedia('(pointer: coarse)').matches) props.onOpen();
  }

  return (
    <button
      class="desktop-icon"
      classList={{ selected: props.selected }}
      onClick={handleClick}
      onDblClick={(event) => {
        event.stopPropagation();
        props.onOpen();
      }}
      onKeyDown={(event) => {
        if (event.key === 'Enter') props.onOpen();
      }}
      aria-label={`Open ${props.label}`}
    >
      <Show when={props.project} fallback={<PixelIcon name={props.icon} size={38} />}>
        {(project) => <ProjectIcon project={project()} size={38} />}
      </Show>
      <span>{props.label}</span>
    </button>
  );
}
